<template>
  <div class="wrapper container">

    <div class="menu-wrapper" v-if="!isMobile">
      <div class="menu">
        <h1 class="menu-title">TGO 鲲鹏会全球活动 </h1>
        <p :class="{'active': activeIndex === index}" class="question" v-for="(item, index) in menuList" :key="item + '' + index" @click="scrollToTarget(index)">{{index + 1 + '.' + item}}</p>
      </div>
    </div>

    <div v-else class="menu-m">{{ menuList[activeIndex] }}</div>

    <div class="content">

      <h2 class="title">TGO 鲲鹏会全球活动 </h2>

      <div id="item-1" class="item one index">
        <h4 class="sub-title">定义你的 TGO 鲲鹏会之旅</h4>
        <p class="justify">TGO 鲲鹏会学员秉承“投入越多，收获越多”的理念，积极参与到所有的活动中，与其他学员建立深厚连接并从中不断收获价值。TGO 鲲鹏会的活动包含以下 7 个方面，每位学员都可以自由选择其中的部分或全部活动（部分活动可能需要付费或缴纳保证金），来自定义每个人在 TGO 鲲鹏会的体验之旅。</p>
      </div>

      <div id="item-2" class="item two index">
        <h4 class="sub-title">全球经验对话</h4>
        <div class="right">
          <img src="./assets/image/1.png" preview="0" width="100%" alt="">
        </div>
        <div class="left">
          <p class="unit justify">在人工智能、大数据、区块链技术飞速发展的大背景下，如何有效应对未来将出现的机遇与挑战，需要领导者兼具敏锐的商业洞察力和掌握最前沿的技术变革。美国硅谷、以色列、日本是人工智能与大数据、精密制造等领域高科技企业及行业领导者的聚集地，在这里可以探索未来科技发展的信号，与高科技公司技术团队进行思维的碰撞。</p>
          <p class="unit justify">ChinaTech Day 中国技术开放日借助于 TGO 鲲鹏会的全球学员网络，将更加紧密地链接全球顶尖企业和科技领导者，为个人成长、团队发展和企业壮大提供助力。</p>
          <p class="unit">更多内容，请<a href="http://www.chinatechday.com" class="primary">点此查看</a></p>
        </div>
      </div>

      <div id="item-3" class="item three index">
        <h4 class="sub-title">私密小组活动</h4>
        <div class="right">
          <img src="./assets/image/2.png" preview="1" width="100%" alt="">
        </div>
        <div class="left">
          <p class="unit justify">⼩组是 TGO 鲲鹏会最核⼼的产品，也是各城市最核⼼的组成单元。所有学员属于不同的 TGO 鲲鹏会小组。</p>
          <p class="unit justify">在健康运营的情况下，小组会议讨论的内容是在一般社交场合不会涉及也不愿涉及的话题，只有在安全的小组氛围内才会分享的，我们称为 5% 话题，可以是⽣活中最不堪、最纠结、最痛苦的内容，也可以是最喜悦、最感动、最顿悟的时刻。5% 话题通常能够表现自己的脆弱性（Vulnerability），展现自己最柔软的那一部份。这是小组彼此获得信任和建立连接的关键。</p>
          <p class="unit">更多内容，请登录 TGO 鲲鹏会学员专属 Tower 社区查看，请<a href="https://tower.im/teams/d7eecb5a223c4421884297fd43f133be/projects" class="primary">点此查看</a></p>
        </div>
      </div>

      <div id="item-4" class="item four index">
        <h4 class="sub-title">年度团聚家宴</h4>
        <div class="right">
          <el-carousel :autoplay="false" height="200px">
            <span class="imgLength">{{`共 ${item4ImgList.length} 张`}}</span>
            <el-carousel-item v-for="item4 in item4ImgList" :key="item4">
              <img :src="item4" preview="2" width="100%" height="200px" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="left">
          <p class="unit justify">自 2015 年成立，年度团聚家宴（原名 E 家宴）一直是 TGO 鲲鹏会当地年度最重要的活动。他是学员专享的年度休闲社交活动，旨在加强学员之间的了解沟通，推动本地技术社区的分享和交流，一年一度汇聚当地学员，一起辞旧迎新。</p>
        </div>
      </div>

      <div id="item-5" class="item five index">
        <h4 class="sub-title">月度公开学习活动</h4>
        <div class="right">
          <el-carousel :autoplay="false" height="200px">
            <span class="imgLength">{{`共 ${item5ImgList.length} 张`}}</span>
            <el-carousel-item v-for="item5 in item5ImgList" :key="item5">
              <img :src="item5" preview="2" width="100%" height="200px" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="left">
          <p class="unit justify">TGO 鲲鹏会全球 12 个城市，每个月均有至少一场线下公开学习活动，内容覆盖创业、管理、团队、架构、商业、运营、产品、资本等话题。所有 TGO 鲲鹏会学员都可以自由免费参加全部活动。</p>
          <p class="unit justify">各个城市的月度公开学习活动由当地董事会成员制定规划悟的时刻。5% 话题通常能够表现自己的脆弱性（Vulnerability），展现自己最柔软的那一部份。这是小组彼此获得信任和建立连接的关键。</p>
          <p class="unit">TGO 鲲鹏会全年学习活动，请<a href="https://tgo.infoq.cn/event" class="primary">点此查看</a></p>
        </div>
      </div>

      <div id="item-6" class="item six index">
        <h4 class="sub-title">技术高管培训</h4>
        <div class="right">
          <el-carousel :autoplay="false" height="213px">
            <span class="imgLength">{{`共 ${item6ImgList.length} 张`}}</span>
            <el-carousel-item v-for="item6 in item6ImgList" :key="item6">
              <img :src="item6" preview="4" width="100%" height="200px" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="left">
          <p class="unit justify">而 TGO 鲲鹏会小组，提供了锻炼领导力的绝佳场合。一个优秀的小组组长，必然能够承担好 CEO 和 COO 的两个角色。<span class="strong">CEO 的角色：</span>确定小组的使命和愿景，带领小组共同前进；<span class="strong">COO 的角色：</span>组织每月小组会议。通过 TGO 鲲鹏会的新学员培训和组长领导力培训，我们为所有的学员提供了领导力提升的方法、指南和锻炼场景。</p>
          <p class="unit">关于培训体系的更多内容，请登录 TGO 鲲鹏会学员专属 Tower 社区查看，请<a href="https://tower.im/teams/612908/projects/734" class="primary">点此查看</a></p>
        </div>
      </div>

      <div id="item-7" class="item seven index">
        <h4 class="sub-title">荣誉导师辅导</h4>
        <div class="right">
          <el-carousel :autoplay="false" height="200px">
            <span class="imgLength">{{`共 ${item7ImgList.length} 张`}}</span>
            <el-carousel-item v-for="item7 in item7ImgList" :key="item7">
              <img :src="item7" preview="5" width="100%" height="200px" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="left">
          <p class="unit justify">TGO 鲲鹏会荣誉导师在业界享有一定的声誉，并对行业的发展做出了突出的贡献，被业界公认为技术人的榜样，经 TGO 鲲鹏会总部同意，授权其“荣誉导师”称呼，为 TGO 鲲鹏会学员传道授业解惑。TGO 鲲鹏会不定期邀请导师做分享，比如阿里巴巴王坚博士、同程旅游联合创始人兼 CTO 张海龙、环球易购 CTO 乔新亮等人，都是 TGO 鲲鹏会荣誉导师。我们希望科技领导者们聚在一起，散发出更多的能量，来给我们的科技圈带来源源不断的创意和推力，一起来创造和改变未来的世界。</p>
        </div>
      </div>

      <div id="item-8" class="item eight index">
        <h4 class="sub-title">全球技术领导力峰会（GTLC）</h4>
        <div class="right">
          <img src="./assets/image/11.jpg" preview="6" width="100%" alt="">
        </div>
        <div class="left">
          <p class="unit justify">Global Tech Leadership Conference，简称 GTLC，中文名称为全球技术领导力峰会，是 TGO 鲲鹏会主办的高端科技领导者盛会。GTLC 峰会 · 全球站大会为期两天，主要面向 CTO、技术 VP、技术团队 Leader、技术项目负责人等对领导力感兴趣的技术管理者。在 GTLC 峰会 · 全球站，你将与 1700+ 位CTO 及优秀技术管理大咖同行，获得10多位科技圈内顶尖领袖的实战经验和视野启发。</p>
          <!-- <p class="unit justify">在 GTLC 峰会 · 全球站之外，TGO 鲲鹏会也会举办 GTLC 峰会 · 分站，将技术领导力实战经验撒播到所有城市。</p> -->
          <p class="unit">更多内容，请<a href="https://gtlc.infoq.cn/2020/beijing" class="primary">点此查看</a></p>
        </div>
      </div>

      <div id="item-9" class="item nine index">
        <h4 class="sub-title">即刻申请加入 TGO 鲲鹏会</h4>
        <img class="unit" src="../../assets/img/t1.png" preview="7" width="100%" alt="">
        <p class="unit">请<a href="https://tgo.infoq.cn/join" class="primary">点击链接</a>，即刻申请</p>
      </div>

    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      fixed: false,
      activeIndex: 0,
      itemTopList: [],
      menuList: [
        '定义你的 TGO 鲲鹏会之旅',
        '全球经验对话',
        '私密小组活动',
        '年度团聚家宴',
        '月度公开学习活动',
        '技术高管培训',
        '荣誉导师辅导',
        '全球技术领导力峰会（GTLC）',
        '即刻申请加入 TGO 鲲鹏会'
      ],
      item4ImgList: [
        require('./assets/image/3.png'),
        require('./assets/image/4.jpeg')
      ],
      item5ImgList: [
        require('./assets/image/y1.png'),
        require('./assets/image/y2.png')
      ],
      item6ImgList: [
        require('./assets/image/6.jpeg'),
        require('./assets/image/7.png')
      ],
      item7ImgList: [
        require('./assets/image/8.jpg'),
        require('./assets/image/9.jpg'),
        require('./assets/image/10.jpg')
      ]
    }
  },
  components: {},
  computed: {
    ...mapState({
      isMobile: 'isMobile'
    })
  },
  methods: {
    scrollToTarget (i) {
      window.removeEventListener('scroll', this.listenScrollTop)
      this.activeIndex = i
      this.$scrollTo(`#item-${i + 1}`, 500, {
        offset: -76,
        onDone: () => {
          window.addEventListener('scroll', this.listenScrollTop)
        }
      })
    },
    listenScrollTop () {
      var nowY = window.pageYOffset
      var index = 0

      if (nowY > this.itemTopList[0]) {
        this.fixed = true
      } else {
        this.fixed = false
      }

      while (nowY > this.itemTopList[index]) {
        index++
      }
      if (index !== 0) index--
      // this.activeIndex = index
      if (window.pageYOffset > (document.body.offsetHeight - window.innerHeight - 100)) {
        this.activeIndex = this.itemTopList.length - 1
      } else {
        this.activeIndex = index
      }
    }
  },
  created () {
  },
  mounted () {
    var itemList = document.getElementsByClassName('index')
    itemList.forEach(ele => {
      this.itemTopList.push(ele.offsetTop)
    })

    window.addEventListener('scroll', this.listenScrollTop, false)
  }
}
</script>
<style scoped lang='scss'>
  @import '../../style/bulma/app.sass';
  @import '../../style/base/article.scss';

  .container {
    display: flex;
    @include mobile {
      padding-top: 3rem;
    }
  }

  .menu {
    position: sticky;
    top: 60px;
    width: 255px;
    // border-right: 1px solid rgba(235, 235, 235, 0.5);
    padding: 64px 0;
    &::after {
      content: '';
      width: 1px; height: calc(100% - 128px);
      background-color: rgba(235, 235, 235, 0.5);
      position: absolute; right: 0; top: 64px;
    }

    .menu-title {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    .question {
      width: 210px;
      color: #4A4A4A;
      font-size: 13px;
      margin-bottom: 15px;
      cursor: pointer;
    }

    .active {
      color: $primary3;
    }
  }

  .menu-m {
    position: fixed; top: 0; left: 0; z-index: 100;
    width: 100%;
    // height: 35px;
    font-size: 18px;
    font-weight: 500;
    text-align: left;
    line-height: 30px;
    background: #fff;
    border-left: 3px solid $primary3;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .content {
    margin-left: 65px;
    margin-right: 0;
    margin-bottom: 80px;
    @include mobile {
      margin: 0;
      .sub-title {
        line-height: 1.3;
      }
      .twelve {
        margin-bottom: 20px;
      }
    }
  }

  .imgLength {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 50px;
    height: 20px;
    color: #fff;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    background: rgba(0,0,0,.6);
    border-radius: 10px;
    z-index: 10;
  }

  ::v-deep .el-carousel__indicators {
    display: none;
  }
  ::v-deep .el-carousel__arrow {
    width: 28px;
    height: 28px;
    background: rgba(0,0,0,.8);
    font-size: 14px;
    &:hover {
      background: rgba(0,0,0,.8);
    }
  }
  ::v-deep .el-icon-arrow-left {
    font-weight: 1000;
  }
  ::v-deep .el-icon-arrow-right {
    font-weight: 1000;
  }
  @include mobile {
    ::v-deep .el-carousel__item {
      border-radius: 5px;
    }
  }
</style>
